<template>
    <div>
        <!-- Update form -->
        <div class="row pt-1">
            <div class="col">
                <form ref="form">
                    <div class="row">
                        <div class="col-lg-6 mb-12 d-flex flex-column">
                            <h3>Password</h3>
                            <p class="sau-font sm">Use strong passwords to protect your account. &nbsp;</p>

                            <div class="sau-bx p-6 mt-auto">
                                <span class="mb-12">Password</span>
                                <br>
                                <div>
                                    <span class="sau-pwd-dot"></span>
                                    <span class="sau-pwd-dot"></span>
                                    <span class="sau-pwd-dot"></span>
                                    <span class="sau-pwd-dot"></span>
                                    <span class="sau-pwd-dot"></span>
                                    <span class="sau-pwd-dot"></span>
                                    <b-link href="#" class="sau-linx green sau-font sm px-2" v-b-modal.change-password>Change</b-link>
                                    <i v-if="isUpdating.password" class="far fa-spinner-third fa-spin"></i>
                                    <sau-utility-msg-inline v-if="controls.passwordHasUpdated">
                                        <template slot="msg">
                                            Password Updated
                                            <i class="far fa-check fa-lg sau-font-color green"></i>
                                        </template>
                                    </sau-utility-msg-inline>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-12">
                            <h3>Account Verification Password</h3>
                            <p class="sau-font sm">Create a memorable Account Verification Password to be used when calling Servers Australia to quickly verify your identity.</p>
                            <div class="sau-bx p-6">
                                <span class="mb-12">Account Verification Password</span>
                                <br>
                                <div v-if="userDetails.account_pin" class="d-inline-block">
                                    <div v-show="!showAccessPassword">
                                        <!-- Match the dots to the password length -->
                                        <span class="sau-pwd-dot space" v-for="(key, index) in userDetails.account_pin.length" :key="index"></span>
                                        <a href="#" class="sau-linx green sau-font sm pl-2" @click.prevent="showAccessPassword = !showAccessPassword">Show</a> /
                                        <b-link v-if="hasProfilePermissions" href="#" class="sau-linx green sau-font sm" v-b-modal.change-pin>Change</b-link>
                                        <i v-if="isUpdating.pin" class="far fa-spinner-third fa-spin"></i>
                                    </div>
                                    <div v-show="showAccessPassword">
                                        <span class="clear-password wm-hide">{{userDetails.account_pin}}</span>
                                        <a href="#" class="sau-linx green sau-font sm pl-2" @click.prevent="showAccessPassword = !showAccessPassword">Hide</a> /
                                        <b-link v-if="hasProfilePermissions" href="#" class="sau-linx green sau-font sm" v-b-modal.change-pin>Change</b-link>
                                        <i v-if="isUpdating.pin" class="far fa-spinner-third fa-spin"></i>
                                    </div>
                                </div>
                                <div v-else class="d-inline-block">
                                    <b-link v-if="hasProfilePermissions" href="#" class="sau-linx green sau-font sm" v-b-modal.change-pin>Add</b-link>
                                    <i v-if="isUpdating.pin" class="far fa-spinner-third fa-spin"></i>
                                </div>
                                <sau-utility-msg-inline v-if="controls.verificationPasswordHasUpdated">
                                    <template slot="msg">
                                        Password Updated
                                        <i class="far fa-check fa-lg sau-font-color green"></i>
                                    </template>
                                </sau-utility-msg-inline>
                            </div>
                        </div>
                    </div>

                    <template>
                        <div class="row">
                            <div class="col-sm-12 col-lg-6">
                                <h3>Two Factor Authentication</h3>
                                <p class="sau-font sm">Enable to increase your portal security. When enabled, you will be required to enter a second authentication method such as receiving an SMS or using a code on Google Authenticator.</p>

                                <!-- Alert if only one auth method enabled -->
                                <div v-if="showSingleMethodAlert" class="alert alert-warning mt-3" role="alert">
                                    <p class="mb-0 text-xs">You have only one two-factor authentication method on your account. We recommend enabling additional methods to avoid losing access.</p>
                                </div>

                                <div class="sau-bx p-6">
                                    <div class="row">
                                        <div class="col">
                                            <!-- Select Method -->
                                            <div class="form-group">
                                                <b-form-select v-model="form.two_factor_method" :options="twoFactorOptions" @change="twoFactorDidChange"/>
                                            </div>
                                            <template v-if="!mobile && !authenticator">
                                                <!-- Two Factor Mobile -->
                                                <div class="form-group mt-4" v-if="form.two_factor_method === 'mobile' && userDetails.two_factor_mobile">
                                                    <label for="two_factor_mobile">Your two-factor verification code will be sent to</label>
                                                    <p class="mt-2">{{ form.two_factor_mobile }}</p>
                                                </div>
                                                <!-- Two Factor Email -->
                                                <div class="form-group mt-4" v-if="form.two_factor_method === 'email'">
                                                    <label for="two_factor_mobile">
                                                        Email Address
                                                        <span class="sau-help sm ml-2 align-middle" v-b-tooltip.hover :title="popup">?</span>
                                                    </label>
                                                    <p class="mt-2">{{ form.email }}</p>
                                                </div>
                                                <button v-if="shouldShowTwoFactorButton" class="btn btn-success mt-2" @click.prevent="goToTwoFactorSetup()">{{twoFactorButtonText}}</button>
                                            </template>
                                            <template v-else-if="mobile">
                                                <div class="mt-4">
                                                    <sau-account-two-factor-device-verification method="mobile"></sau-account-two-factor-device-verification>
                                                </div>
                                            </template>
                                            <template v-else-if="authenticator">
                                                <div class="mt-4">
                                                    <sau-account-authenticator-setup :image="QR_Image" :secret="secret"></sau-account-authenticator-setup>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </template>
                </form>
            </div>
        </div>
        <!-- Change passowrd modal -->
        <sau-utility-account-password v-on:password:update="updatePassword"></sau-utility-account-password>
        <!-- Change pin modal -->
        <sau-utility-account-pin v-on:pin:update="updatePin"></sau-utility-account-pin>
    </div>
</template>
<script>
import { required, sameAs } from "vuelidate/lib/validators";
import AccountAuthenticatorSetup from "./_AuthenticatorSetup";
import TwoFactorDeviceVerification from "./_TwoFactorDeviceVerification";
export default {
    components: {
        "sau-account-two-factor-device-verification": TwoFactorDeviceVerification,
        "sau-account-authenticator-setup": AccountAuthenticatorSetup
    },

    data() {
        return {
            showAccessPassword: false,
            popup: 'To update your email address please click on "Account Summary" then "Update your profile"',
            customFields: {},
            hasProfilePermissions: false,
            mobile: false,
            authenticator: false,
            QR_Image: "",
            secret: "",
            controls: {
                showAccessPassword: false,
                showaccount_pin: false,
                passwordHasUpdated: false,
                verificationPasswordHasUpdated: false
            },
            form: {
                two_factor_method: "",
                two_factor_mobile: "",
                email: ""
            },
            status: "not_accepted",
            error: {
                message: "We cant find it yet"
            },
            isUpdating: {
                twoFactor: false,
                password: false,
                pin: false
            },
        };
    },
    validations: {
        form: {
            two_factor_method: {},
            two_factor_mobile: {},
            email: {}
        }
    },
    mounted() {
        this.form.two_factor_method = this.userDetails.two_factor_method;
        this.form.two_factor_mobile = this.userDetails.two_factor_mobile;
        this.form.email = this.userDetails.email;

        if (!this.userDetails.whmcs_contact_id) {
            this.hasProfilePermissions = true;
        } else {
            this.hasProfilePermissions = this.userDetails.permissions.split(",").indexOf("profile") > -1 ? true : false;
        }
    },

    methods: {
        twoFactorDidChange() {
            Vue.nextTick(
                function() {
                    switch (this.form.two_factor_method) {
                        case "email":
                            this.mobile = this.authenticator = false;
                            return this.updateTwoFactor();
                            break;
                        case "mobile":
                            this.authenticator = this.mobile = false;
                            return this.userDetails.two_factor_mobile ? this.updateTwoFactor() : this.goToTwoFactorSetup();
                            break;
                        case "authenticator":
                            this.mobile = false;
                            return this.userDetails.google2fa_secret ? this.updateTwoFactor() : this.goToTwoFactorSetup();
                            break;
                        default:
                            this.authenticator = this.mobile = false;
                            return this.updateTwoFactor();
                            break;
                    }
                }.bind(this)
            );
        },
        goToTwoFactorSetup() {
            switch (this.form.two_factor_method) {
                case "mobile":
                    /** Flag mobile two factor component */
                    this.mobile = true;
                    break;
                case "authenticator":
                    /** Flag authenticator two factor component */
                    this.authenticator = true;
                    /** get authenticator details */
                    this.getAuthenticatorDetails();
                    break;
                default:
                    return false;
            }
        },
        getAuthenticatorDetails() {
            this.getAccountAuthenticatorDetails().then(response => {
                this.QR_Image = response.data.QR_Image;
                this.secret = response.data.secret;
            });
        },
        updateTwoFactor() {
            if (!this.twoFactorIsValid) {
                return this.$swal({
                    type: "warning",
                    title: "Please setup and verify your two factor method first",
                    showConfirmButton: false,
                    timer: 3000
                });
            }
            this.isUpdating.twoFactor = true;
            this.updateAccountTwoFactor({ two_factor_method: this.form.two_factor_method })
                .then(response => {
                    this.isUpdating.twoFactor = false;
                    this.$swal({
                        type: "success",
                        title: "Settings Updated",
                        showConfirmButton: false,
                        timer: 3000
                    });
                })
                .catch(error => {
                    this.isUpdating.twoFactor = false;
                    this.$swal({
                        type: "error",
                        title: "There was a problem updating your profile",
                        showConfirmButton: false,
                        timer: 3000
                    });
                });
        },
        updatePassword(password) {
            this.controls.passwordHasUpdated = false;
            this.isUpdating.password = true;
            this.updateAccountPassword({ password: password, password_confirmation: password })
                .then(response => {
                    this.isUpdating.password = false;
                    this.controls.passwordHasUpdated = true;
                })
                .catch(error => {
                    this.isUpdating.password = false;
                    this.$swal({
                        type: "error",
                        title: "There was a problem updating your password",
                        showConfirmButton: false,
                        timer: 3000
                    });
                });
        },
        updatePin(pin) {
            this.controls.verificationPasswordHasUpdated = false;
            this.isUpdating.pin = true;
            this.updateAccountPin({ account_pin: pin })
                .then(response => {
                    this.isUpdating.pin = false;
                    this.controls.verificationPasswordHasUpdated = true;
                    this.$store.commit("setAccountPin", pin);
                })
                .catch(error => {
                    this.isUpdating.pin = false;
                    this.$swal({
                        type: "error",
                        title: "There was a problem updating your Password",
                        showConfirmButton: false,
                        timer: 3000
                    });
                });
        },

    },
    computed: {
        enabledAlternateMethods() {
            let keys = ['two_factor_mobile', 'google2fa_secret'];
            return this.userDetails ? keys.filter(key => this.userDetails[key]) : [];
        },

        showSingleMethodAlert() {
            return this.userDetails && this.enabledAlternateMethods.length === 0;
        },
        
        twoFactorIsValid() {
            switch (this.form.two_factor_method) {
                case "mobile":
                    return this.userDetails.two_factor_mobile ? true : false;
                    break;
                case "email":
                    return true;
                    break;
                case "authenticator":
                    return this.userDetails.google2fa_secret;
                    break;
                case null:
                    return true;
                    break;
                default:
                    return false;
                    break;
            }
        },
        twoFactorButtonText() {
            switch (this.form.two_factor_method) {
                case "mobile":
                    return this.userDetails.two_factor_mobile ? "Change Mobile" : "Setup Mobile";
                    break;
                case "authenticator":
                    return this.userDetails.google2fa_secret ? "Reset Authenticator" : "Setup Authenticator";
                    break;
                default:
                    return "";
                    break;
            }
        },
        shouldShowTwoFactorButton() {
            return this.form.two_factor_method === "authenticator" || this.form.two_factor_method === "mobile";
        },
        twoFactorOptions() {            
            const twoFactorMethods = [
                { value: null, text: "Disabled" },
                { value: "email", text: "Email" },
                { value: "mobile", text: "SMS" },
                { value: "authenticator", text: "Google Authenticator", disabled: false }
            ];

            if (this.userDetails.two_factor_method) {
                return twoFactorMethods.filter(option => option.value !== null);
            }

            return twoFactorMethods;
        }
    }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.space {
    margin: 0px 2px;
}
</style>
